function scrollFX() {
  var $window = $(window),
      scrollTop = $window.scrollTop(),
      windowWidth = $window.width(),
      $boxes = $('[data-scroll-speed]'),
      $paraOne = $('#mainWrap > .slideshow:first-child .paraOne'),
      $paraTwo = $('#mainWrap > .slideshow:first-child .paraTwo'),
      tranY1 = $window.scrollTop() / 2.5 + 'px',
      tranY2 = $window.scrollTop() / 10000 + 'px',
      $header = $('header'),
      $scrollDown = $('.scrollDown'),
      altProdHeader = $('header.scrollFX');

  if($scrollDown.size() > 0) {
     if(scrollTop > 20) {
       $scrollDown.addClass('hidden');
     }else{
       $scrollDown.removeClass('hidden');
     }
  }

  if (altProdHeader.length > 0 && $('.template-index, .template-product-alternate').length) {
    if (scrollTop > 20) {
      altProdHeader
        .addClass('scrolled')
        .removeClass('isTran');
    } else {
      altProdHeader
        .addClass('isTran')
        .removeClass('scrolled');
    }
  }

  $boxes.each(function() {
      var $this = $(this),
        oTop = scrollTop - $this.offset().top,
        scrollspeed = parseInt($this.data('scroll-speed')),
        val = -oTop / scrollspeed;
      $this.css('transform', 'translateY(' + val + 'px)');
    });

  //Hero
  if($paraOne.size() > 0) {
    $paraOne.css({
      transform: 'translateY(' + tranY1 + ')',
      MozTransform: 'translateY(' + tranY1 + ')',
      WebkitTransform: 'translateY(' + tranY1 + ')',
      msTransform: 'translateY(' + tranY1 + ')'
    });
    $paraTwo.css({
      transform: 'translateY(' + tranY2 + ')',
      MozTransform: 'translateY(' + tranY2 + ')',
      WebkitTransform: 'translateY(' + tranY2 + ')',
      msTransform: 'translateY(' + tranY2 + ')'
    });
  }
}

function openPopOut(target, t, line_item) {
  var $target = $(target),
      $popOuts = $('#popOuts'),
      $body = $('body'),
      $frame = $('#site-border'),
      currentPos = $(window).scrollTop(),
      closePopout;

  $popOuts.css('background','rgba(0,0,0,0.8)');
  $popOuts.addClass('active');
  $body.addClass('popOutFix');
  $frame.addClass('popOutFix');
  $target.show();

  if ( $target.attr('id') == 'gallery' ) {
    $popOuts.css('background','rgba(255,255,255,0.8)');
    var scrolltoimg = $('.productThumbs').length ? $('.productThumbs a.active').attr('data-index_id') : '#indexImage_1';
    scrolltoimg = $target.find('img').filter(scrolltoimg).offset().top
    $popOuts.scrollTop(scrolltoimg);
  }

  setTimeout(function(){
    $target.addClass('active');
  },600);

  $('.closePopOut').click(function(e) {
    e.preventDefault();
    closePopout();
  });

  $target.find('form').submit(function(e) {
    closePopout();
  });

  window.closePopout = closePopout = function() {
    $target.removeClass('active');
    $body.scrollTop(currentPos);

    setTimeout(function () {
      $popOuts.removeClass('active');
      $body.removeClass('popOutFix');
      $frame.removeClass('popOutFix');
      $target.hide();
    }, 600);
  }
}

window.slideshows = [];

function setSlick(target) {
  target.each(function() {
    var $t = $(this),
      $n = $t.closest('.slickSlider').find('span.next'),
      $p = $t.closest('.slickSlider').find('span.prev'),
      $full = parseInt($t.attr('data-full'), 10),
      $tab = parseInt($t.attr('data-tab'), 10),
      $mob = parseInt($t.attr('data-mob'), 10),
      slides = $t.find('li').size(),
      $auto = $t.attr('data-auto'),
      swipe = $t.attr('data-swipe') ? $t.attr('data-swipe') : true
      fade = $t.closest('.slickSlider').attr('data-transition') === 'fade';

    if($auto === "true") {
      $auto = true;
    } else {
      $auto = false;
    }

    var $time = parseInt($t.attr('data-timeout'), 10)
    if(slides > 1) {
      var SlickSlider = $t.slick({
        autoplay: $auto,
        autoplaySpeed: $time,
        slidesToShow: $full,
        swipe: swipe,
        pauseOnHover: true,
        speed: 700,
        infinite: true,
        arrows: false,
        accessibility: false,
        dots: false,
        fade: fade,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: $full
            }
          },
          {
            breakpoint: 736,
            settings: {
              slidesToShow: $tab
            }
          },
          {
            breakpoint: 568,
            settings: {
              slidesToShow: $mob
            }
          }
        ],
        touchDrag: true,
        mouseDrag: false
      });
      $n.click(function() {
        SlickSlider.slick('slickNext')
      });
      $p.click(function() {
        SlickSlider.slick('slickPrev')
      });

      window.slideshows.push(SlickSlider);
    }
  });
}

function showNewsLetterLanding(timeOut) {
  setTimeout(function() {
    if(!$.cookie('initSignUp')) {
      openPopOut('#newsLetter');
      $.cookie('initSignUp', true, {
        expires: null
      })
    }
  }, timeOut);
}

function showNewsLetterLeaving() {
  if(!$.cookie('exitIntent')) {
    openPopOut('#newsLetter');
    $.cookie('exitIntent', true, {
      expires: null
    })
  }
}

function isotopeblog(){
  var blog = $('.blogListing');

  if (!blog.length) return;

  blog.imagesLoaded(function(){
    $('.blogListing').isotope({
       itemSelector: 'li',
       percentPosition: true,
       layoutMode: 'fitRows'
    });
  });
}

function initTwitter() {
  var twitterContainer = $('.twitterFeed');
  var accessToken = twitterContainer.attr('data-access-token');
  var scriptURL = twitterContainer.attr('data-script-url');

  if (!twitterContainer.length || accessToken == null || !accessToken.length) return;

  if (!window.twitterFetcher) {
    $.getScript(scriptURL, handleScript);
  } else {
    handleScript();
  };

  function handleScript() {
    twitterFetcher.fetch({
      "id": accessToken,
      "domId": "tFeed",
      "maxTweets": 1,
      "enableLinks": true,
      "showPermalinks": false,
      "showImages": false,
      "showRetweet": false,
      "showInteraction": false,
      "showTime": false
    });
  }
}

var initHeader = function() {
  var firstSlideshow = $('#mainWrap > .slideshow:first-child')

  if (!firstSlideshow.length) {
    if (document.body.classList.contains("template-index")) {
      $('header').removeClass('isTran')
    }

    if ($('header.sticky').length) {
      firstSlideshow.addClass('sticky-offset')
    }
  }

  setTimeout(function() {
    if ($('header.sticky').hasClass('isTran')) {
      $(document.body).addClass('has-sticky-tran-header')
    }
  })
}

$(document).ready(function() {

  initHeader();
  scrollFX();
  initFitVids();

  //Account Actions
  $('.address-delete').click(function(e) {
    e.preventDefault();
    var $el = $(this),
    formId = $el.data('form-id'),
    confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
      Shopify.postLink('/account/addresses/' + formId, {'parameters': { '_method': 'delete' }});
    }
  });

  $('.editAddress').click(function(e) {
    e.preventDefault();
    var $id = $(this).attr('href').replace('#', '');
    $('#EditAddress_addNew').hide();
    $('.editAddressForm').hide();
    $('#EditAddress_' + $id).show();
    $('#EditAddress_' + $id).find('.cancelEdit').click(function(e) {
      e.preventDefault();
      $('#EditAddress_' + $id).hide();
      $('#EditAddress_addNew').show();
    });
  });

  setupPopOut();

  //product page
  setupTabs();
  setupVariantSelector();
  setupImagePop();

  //back to top button
  $('.toTop').click(function(e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: 0
    }, "1200");
  });

  //ajax update cart
  $('.qtyInput').change(function(){
    var qtyInput = $(this);
    Shopify.updateCartPage(qtyInput);
  });

  initTwitter();

  isotopeblog();
});

$(window).load(function() {
  setSlick($('.slickSlider ul'));
  $('main').animate({opacity: "1"},600)
});

$(window).scroll(function() {
  scrollFX();
});

$(window).resize(function() {
  scrollFX();
});

function setupPopOut() {
  var popouts = $('#popOuts');

  if (!popouts.length) return;

  var showOnExit = (popouts.attr('data-show-exit') === "true");
  var showOnEntrance = (popouts.attr('data-show-entrance') === "true");
  var entranceDelay = Number(popouts.attr('data-entrance-delay')) * 1000;

  if (showOnExit) {
    $(document).mouseleave(function(){
      showNewsLetterLeaving();
    });
  };

  if (showOnEntrance) {
    showNewsLetterLanding(entranceDelay);
  };
}

function setupTabs() {
  $('.accordHeaderLinks a').click(function(e) {
    e.preventDefault();
    var $t = $(this),
      section = $('.accordian section');
    $t.siblings().removeClass('active');
    $t.addClass('active');
    section.removeClass('active').filter($t.attr('href')).addClass('active')
  });
};

function setupVariantSelector() {

  var elements = document.querySelectorAll("[data-product-form]");

  elements.forEach(function (element) {
    ProductForm(element);
  });

  function ProductForm(element) {
    var $element = $(element);

    if (!$element.length) return;

    var variantStyle = $element.attr('data-variant-style');
    var optionsSize = Number($element.attr('data-options-size'));
    var variantsSize = Number($element.attr('data-variants-size'));
    var firstOption = $element.attr('data-first-option');
    var firstVariantTitle = $element.attr('data-first-variant-title');

    var template_index = document.body.classList.contains("template-index");

    var product = $element.find("[data-product-json]").html(),
        product = JSON.parse(product);

    var option_library = (variantStyle === "buttons") ? $element.attr('data-variant-selection-js') : $element.attr('data-option-selection-js');

    if ( template_index ) {
      option_selectors();
    } else {
      $.getScript(option_library, option_selectors);
    }

    function option_selectors(data) {
      new Shopify.OptionSelectors('ProductSelect-' + product.id, {
        product: product,
        enableHistoryState: template_index ? false : true,
        onVariantSelected: function(variant, selector) {
          timber[(variantStyle === "buttons" ? "productPage" : "productPageRegular")]($element, {
            money_format: $element.attr('data-money-format'),
            variant: variant,
            selector: selector
          });

          clearInterval(window.buttonInterval);
        }
      });

      if (variantStyle === "buttons") {
        // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
        if (optionsSize == 1 && firstOption != 'Title') {
          $('.radio-wrapper:eq(0)').prepend('<label for="ProductSelect-option-0" class="single-option-radio__label">' + firstOption + '</label>');
        };

        // Hide drop-down selectors if we only have 1 variant and its title contains 'Default'.
        if (variantsSize == 1 && firstVariantTitle.indexOf('Default') !== -1) {
          $('.radio-wrapper').hide();
        };
      } else {
        // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
        if (optionsSize == 1 && firstOption != 'Title') {
          $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">' + firstOption + '</label>');
        };

        // Hide selectors if we only have 1 variant and its title contains 'Default'.
        if (variantsSize == 1 && firstVariantTitle.indexOf('Default') !== -1) {
          $('.selector-wrapper').hide();
        };

        $element.find('select').each(function(i, select) {
          formSelectInit($(select));
        });
      };
    }
  }
};

function setupImagePop() {
  $('.hasPop').click(function(e) {
    e.preventDefault();
    var t = $(this),
    getPopout = t.attr('data-getPopout'),
    getPopout = $('#popOuts .innerWrapper').filter(getPopout)
    t.addClass('active');
    openPopOut(getPopout, t);
  });
};

function initFitVids() {
  var $videoSection = $('.featured-video');
  if ($videoSection.length) {
    $videoSection.fitVids();
  }
}


// -----------------------------------------------------------
// Stacked images with text
// sections/full-page-sections.liquid

var fullPageSection = function(el) {
  var $window = $(window),
      $el = $(el),
      headerDistance = $('header.locked').length ? 121 : 0;

  var _setup = function() {
    var $block = $el.find('.fullPageSection');

    for (i = 0; i < $block.length - 1; i++) {
      var $current_block = $block.eq(i);
      var bounding_rect = $current_block[0].getBoundingClientRect();
      var block_top = bounding_rect.top;
      var block_bottom = bounding_rect.bottom;

      $current_block.toggleClass('fixed-image', block_top <= headerDistance && block_bottom >= headerDistance && !(/ipad/.test(window.navigator.userAgent.toLowerCase())));
    }
  }

  var _bindEvents = function() {
    $window.bind('scroll', _.throttle(_setup.bind(this), 16));
  }

  _bindEvents();
}

$(window).on('load', function() {
  var $fullPageSection = $('.fullPageSectionsWrap');
  if ($fullPageSection.length) {
    $fullPageSection.each(function(i, el) {
      if ($(el).is('[data-animation="true"]')) {
        fullPageSection(el);
      }
    });
  }
});


// -----------------------------------------------------------
// Contact page map

/*============================================================================
  Map Section
==============================================================================*/
var MapSection = (function () {

  var errors = {
    zero_results: "Google Maps is working but it could not find your address.",
    over_query_limit: "You have exceeded the free limit of 25,000 map loads in a 24-hour period. See Google Maps JavaScript API Usage Limits for more information.",
    unknown_error: "There was some kind of an error on Google\u0026#39;s servers. Not your fault. Simply try again by reloading the page.",
    authentication: "Incorrect address or API key."
  };

  var google_api_loaded = false;

  function Map(container) {

    var events = new EventEmitter();
    events.trigger = events.emit; // alias

    window.gm_authFailure = function () {
      google_api_loaded = false;

      if ( Shopify.designMode ) {
        events.trigger("gmauthfailure:themeeditor");
      } else {
        events.trigger("gmauthfailure");
      }
    };

    var config = container.querySelector(".map-config").innerHTML,
        config = JSON.parse(config);

    if ( !config.api_key ) {
      return false;
    }

    (function section_container() {
      var element = container;

      events.on("gmauthfailure:themeeditor", error);
      events.on("map:error", error);

      function error() {
        element.classList.add("map-section-load-error");
      }
    })();

    (function error() {
      var element = container.querySelector(".map-error-container");

      events.on("gmauthfailure:themeeditor", show);
      events.on("map:error", show);
      events.on("map:ok", hide);

      function show(message) {
        element.style.display = "block";
        element.querySelector(".map-error").innerHTML = message;
      }

      function hide(message) {
        element.style.display = "none";
      }
    })();

    (function map() {
      var element = container.querySelector(".map-container");

      events.on("ready", geolocate);

      function geolocate() {

        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: config.address }, function(results, status) {
          if ( status == google.maps.GeocoderStatus.OK ) {
            events.trigger("map:ok");
            render(results);
          } else {
            error(status);
          }
        });
      }

      function render(results) {
        element.innerHTML = "";

        var map = new google.maps.Map(element, {
          zoom: config.zoom,
          center: results[0].geometry.location,
          draggable: false,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          styles: config.styles,
          disableDefaultUI: true
        });

        var center = map.getCenter();

        new google.maps.Marker({
          map: map,
          position: center
        });

        google.maps.event.addDomListener(window, "resize", debounce(function () {
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        }));

        $(document).on("shopify:section:unload", function () {
          google.maps.event.clearListeners(map, "resize");
        });
      }

      function error(status) {
        var message = errors.authentication;

        switch (status) {
          case 'ZERO_RESULTS':
            message = errors.zero_results;
            break;
          case 'OVER_QUERY_LIMIT':
            message = errors.over_query_limit;
            break;
          case 'UNKNOWN_ERROR':
            message = errors.unknown_error;
            break;
        }

        if ( Shopify.designMode ) {
          events.trigger("map:error", message);
        }
      }
    })();

    if ( google_api_loaded ) {
      events.trigger("ready");
    } else {
      $.getScript("https://maps.googleapis.com/maps/api/js?key=" + config.api_key, function () {
        google_api_loaded = true;
        events.trigger("ready");
      });
    }
  }

  function MapInit() {
    var container = document.querySelector(".map-section-container");

    if ( container ) {
      Map(container);
    }
  }

  MapInit();

  $(document).on("shopify:section:load", MapInit);

  function debounce(fn, wait, immediate) {
    var timeout;

    wait || (wait = 100);

    return function () {
      var context = this, args = arguments;

      var later = function() {
        timeout = null;

        if ( !immediate ) {
          fn.apply(context, args);
        }
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if ( callNow ) {
        fn.apply(context, args);
      }
    };
  }
})();


// -----------------------------------------------------------
// Contact page map

var contactMap = function() {
  var $map = $('.mapContainer');

  if (!$map.length) return;

  function geolocate() {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  function createMap() {
    return geolocate($map)
      .then(function(results) {
        var map = new google.maps.Map($map[0], {
          zoom: 14,
          center: results[0].geometry.location,
          disableDefaultUI: true
        });
        var center = map.getCenter();

        var marker = new google.maps.Marker({
          map: map,
          position: map.getCenter()
        });

        google.maps.event.addDomListener(window, 'resize', function() {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(center);
        });
      })
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = Theme.localization.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = Theme.localization.addressQueryLimit;
            break;
          default:
            errorMessage = Theme.localization.addressError;
            break;
        }

        $map
          .parent()
          .addClass('page-width map-section--load-error')
          .html('<div class="errors text-center">' + errorMessage + '</div>');
      });
  }

  if (!window.google || !window.google.maps) {
    var key = Theme.mapKey ? Theme.mapKey : '';
    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key).then(createMap);
  } else {
    createMap();
  }
};

$(window).load(function() {
  contactMap();
});


// -----------------------------------------------------------
// Select wrapper

var formSelectInit = function($el) {

  if (!$el.closest('.form-select-wrapper').length && !$el.hasClass('product-single__variants')) {
    $el.wrap('<div class="form-select-wrapper" />').parent().prepend('<span class="selected-text">' + $el.find('option:selected').text() + '</span>');
  }

  var formSelectText = function() {
    var newOption = $el.find('option:selected').text();
    $el.siblings('.selected-text').text(newOption);

    if ($el.hasClass('address-country')) {
      $el.closest('form').find('.address-province').trigger('change');
    }
  }

  var formSelectEvents = function() {
    $el.on('change', function() {
      formSelectText();
    });
  }

  formSelectEvents();
}

$(window).load(function() {
  var $select = $("[data-product-form]").find('select');

  if ($select.length) {
    $select.each(function(i, select) {
      formSelectInit($(select));
    });
  }
});


// -----------------------------------------------------------
// Header cart

var headerCart = function($el) {
  var moneyFormat = $el.data('header-cart'),
      saletag = '<svg aria-hidden="true" focusable="false" role="presentation" class="saletag" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.4142" version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><rect x=".428" width="23.569" height="23.542" fill="none"/><path d="m22.621 5.359c1.428 1.541 1.481 4.064 0 5.662-3.561 3.653-7.213 7.215-10.82 10.822-1.522 1.484-4.133 1.548-5.731 0.067-3.064-2.986-7.041-6.345-3.983-9.645 3.561-3.652 7.213-7.214 10.82-10.821 1.523-1.485 4.133-1.549 5.732-0.068 1.344 1.311 2.672 2.639 3.982 3.983zm-4.897-2.919c-1.013-0.987-2.738-1.018-3.783-0.049-3.659 3.567-7.272 7.18-10.839 10.839-0.943 1.018-0.95 2.708 0 3.733 2.59 2.657 5.339 6.089 7.666 3.932 3.658-3.566 7.272-7.18 10.838-10.838 0.944-1.018 0.951-2.708 0-3.734-1.277-1.31-2.587-2.589-3.882-3.883z" fill-rule="nonzero"/><path d="m14.15 9.848c-0.412-0.413-0.698-0.934-0.849-1.549-0.083-0.339-0.083-0.698 0-1.037 0.281-1.145 1.077-2.004 2.128-2.297 1.016-0.284 2.11 3e-3 2.855 0.748 0.413 0.412 0.698 0.933 0.85 1.549 0.083 0.339 0.083 0.698 0 1.037-0.282 1.145-1.078 2.003-2.129 2.297-1.016 0.284-2.11-3e-3 -2.855-0.748zm3.118-3.118c-0.379-0.379-0.935-0.524-1.452-0.38-0.553 0.154-0.961 0.612-1.119 1.255-0.028 0.115-0.028 0.236 0 0.351 0.088 0.357 0.245 0.651 0.47 0.875 0.378 0.379 0.935 0.525 1.452 0.38 0.552-0.154 0.96-0.611 1.118-1.255 0.029-0.114 0.029-0.236 0-0.351-0.087-0.357-0.245-0.651-0.469-0.875z" fill-rule="nonzero"/></svg>',
      $empty = $el.find('.header-cart-empty');

  var headerCartToggle = function(direction) {
    if (direction === 'show') {
      $el.addClass('animating');
      setTimeout(function() {
        $el.addClass('visible');
        headerCartItemHeight();
        $('[data-product-add-to-cart]').trigger('updateButton');
      }, 200);
    } else {
      $el.removeClass('visible');
      setTimeout(function() {
        $el.removeClass('animating');
      }, 200);
    }
  }

  var headerCartItemHeight = function() {
    var $headerCartItem = $el.find('[data-header-cart-item]');
    $headerCartItem.height('auto');

    $el.imagesLoaded(function() {
      $headerCartItem.each(function(i, el) {
        var $item = $(el);
        $item.height($item.height());
      });
    });
  }

  var headerCartUpdate = function(cart) {

    var cartDiscounts = [];
   // Store/format cart discount information
    if (cart.cart_level_discount_applications.length) {
      for (var i=0; i < cart.cart_level_discount_applications.length; i++) {
        var discount = cart.cart_level_discount_applications[i];
        cartDiscounts.push({
          title: discount.title,
          amount: Shopify.formatMoney(discount.total_allocated_amount, moneyFormat),
        });
       var discountAmount = Shopify.formatMoney(discount.total_allocated_amount, moneyFormat),
          discountTitle = discount.title;
      }
    }
  var $cartDiscount = $('[data-cart-discount]')
    if (discount) {
      $cartDiscount.removeClass('hidden');
      $('.headerCartSubtotalTitle').html(saletag + discountTitle);
      $('.headerCartSubtotal').html("-" + discountAmount);
    }

    var total = Shopify.formatMoney(cart.total_price, moneyFormat);
    $el.find('[data-header-cart-total]').html(total);
    $('.cartItemCount').text(cart.item_count);

    if (cart.item_count === 0) {
      $cartDiscount.hide();
      $('.header-cart-mobile').removeClass('has-items');
      setTimeout(function() {
        $empty.removeClass('hidden');
      }, 300);
    } else {
      $cartDiscount.show();
      $('.header-cart-mobile').addClass('has-items');
      $empty.addClass('hidden');
    }
  }

  var headerCartBuildProduct = function(cart, alreadyInCart, cartItem, quantity) {
    if (alreadyInCart) {
      $el.find('[data-header-cart-item="' + cartItem.id + '"]').find('input').val(quantity);
      headerCartToggle('show');
    } else {

      Shopify.getProduct(cartItem.handle, function(product) {
        var options = product.options;
        var variant;

        for (var i in product.variants) {
          if (product.variants[i].id === cartItem.id) {
            variant = product.variants[i];
          }
        }

        var variantOptions = '';
        if (cartItem.variant_options[0] !== 'Default Title') {
          for (var i in cartItem.variant_options) {
            variantOptions = variantOptions ? variantOptions + '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>' : '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>';
          }
        }

        var itemDiscounts = [];
        // Store/format line discount information
        if (cartItem.line_level_discount_allocations.length) {
          for (var i=0; i < cartItem.line_level_discount_allocations.length; i++) {
            var discount = cartItem.line_level_discount_allocations[i];
            itemDiscounts.push({
              title: discount.discount_application.title,
              amount: Shopify.formatMoney(discount.amount, moneyFormat),
            });
            var discountTitle = discount.discount_application.title,
                discountAmount = Shopify.formatMoney(discount.amount, moneyFormat);
          }
        }

      var itemOriginalPrice = Shopify.formatMoney(cartItem.original_price, moneyFormat),
          itemFinalLinePrice = Shopify.formatMoney(cartItem.final_line_price, moneyFormat);

        var image = Shopify.Image.getSizedImageUrl(cartItem.image, '160x'),
            originalPrice = itemOriginalPrice,
            price = itemFinalLinePrice,
            discounts = itemDiscounts,
            quantityLabel = Theme.localization.cart.quantity,
            soldOutMessage = Theme.localization.cart.allInCart;

        var variantQuantity = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny'
                                ? variant.inventory_quantity
                                : 0;
        variantQuantity = variantQuantity === 0
                            ? ''
                            : 'max="' + variantQuantity + '"';
        var cartItemStart = '<article class="header-cart-item" data-header-cart-item="' + cartItem.id + '">' +
              '<a class="header-cart-item-image" href="' + cartItem.url + '">' +
                '<img src="' + image + '">' +
              '</a>' +
              '<div class="header-cart-item-info">' +
                '<h3><a href="' + cartItem.url + '">' + cartItem.product_title + '</a></h3>';

          if (price === originalPrice) {
            var firstHalf = cartItemStart + '<span class="money">' + price + '</span>';
          } else {
            var firstHalf = cartItemStart +   '<span class="money"><s>' + originalPrice + '</s></span>' + '<span class="money"><strong>' + price + '</strong></span>' +
                saletag +
                '<span class="discount" id="lineLevelDiscount">' + discountTitle + '(-' + discountAmount + ')' + '</span>';
          }

          $el.find('[data-header-cart-items]').append(
            firstHalf +
                '<div class="header-cart-item-options" data-header-cart-options>' +
                  variantOptions +
                  '<span>' +
                    quantityLabel + ' <strong><input type="number" min="0" ' + variantQuantity + ' value="' + cartItem.quantity + '" readonly></strong> ' +
                    '<button type="button" data-header-cart-quantity-increase="' + cartItem.id  +'">&plus;</button> ' +
                    '<button type="button" data-header-cart-quantity-decrease="' + cartItem.id  +'">&minus;</button> ' +
                  '</span>' +
                  '<span class="header-cart-sold-out" data-header-cart-sold-out>' + soldOutMessage + '</span>' +
                '</div>' +
              '</div>' +
            '</article>'
          );

        headerCartToggle('show');
      });
    }
  }

  var headerCartAddItem = function(variantId) {
    var alreadyInCart = false;

    if ($el.find('[data-header-cart-item="' + variantId + '"]').length) {
      alreadyInCart = true;
    }

    Shopify.getCart(function(cart) {
      var cartDiscounts = [];
      var quantity;
      var cartItem;
      $.each(cart.items, function(i, el) {
        if (el.id === parseInt(variantId, 10)) {
          cartItem = el;
          quantity = el.quantity;
        }
      });

      headerCartUpdate(cart);
      headerCartBuildProduct(cart, alreadyInCart, cartItem, quantity,);
    });
  }

  var headerCartMaxReached = function($cartItem) {
    var $target = $cartItem.find('[data-header-cart-sold-out]');

    $target.addClass('visible');

    setTimeout(function() {
      $target.removeClass('visible');
    }, 3000);
  }

  var headerCartEditQuantity = function(event, direction) {
    var $target = $(event.currentTarget),
        id = $target.data('header-cart-quantity-' + direction),
        $input = $target.closest('[data-header-cart-options]').find('input'),
        maxQuantity = $input.attr('max') ? parseInt($input.attr('max'), 10) : 1000000,
        quantity = parseInt($input.val(), 10);

    quantity = direction === 'increase' ? quantity + 1 : quantity - 1;

    if (quantity <= maxQuantity) {
      quantity = quantity;
    } else {
      quantity = quantity - 1;
      headerCartMaxReached($target.closest('[data-header-cart-item]'));
    }

    $input.val(quantity);

    if (quantity === 0) {
      var $item = $target.closest('[data-header-cart-item]');
      headerCartRemove($item, id, headerCartUpdate);
    } else {
      Shopify.changeItem(id, quantity, function(cart) {
        headerCartUpdate(cart);
      });
    }
  }

  var headerCartRemove = function($item, id, callback) {
    Shopify.removeItem(id, function(cart) {
      $item.addClass('removed');

      setTimeout(function() {
        $item.remove();
      }, 200);

      callback(cart);
    });
  }

  var headerCartEvents = function() {
    $el.on('click', '[data-header-cart-quantity-increase]', function(event) {
      headerCartEditQuantity(event, 'increase');
    });

    $el.on('click', '[data-header-cart-quantity-decrease]', function(event) {
      headerCartEditQuantity(event, 'decrease');
    });

    $el.on('update', function(event, variantId) {
      headerCartAddItem(variantId);
    });

    $el.on('mouseleave', function() {
      headerCartToggle('hide');
    });

    $(window).on('resize', function() {
      headerCartItemHeight();
    });
  }

  headerCartItemHeight();
  headerCartEvents();
}

$(window).load(function() {
  headerCart($('[data-header-cart]'));
});

var thumbCurrentItem;

var productThumbTab = function(item, index) {
  var $focusableElements = $(item).find(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
  ).filter(':visible');

  thumbCurrentItem = {
    thumbIndex: index,
    firstFocusable: $focusableElements.eq(0),
    lastFocusable: $focusableElements.eq($focusableElements.length - 1)
  };

  if (thumbCurrentItem.firstFocusable.length && thumbCurrentItem.lastFocusable.length) {
    thumbCurrentItem.lastFocusable.on('focusout', function() {
      thumbCurrentItem.lastFocusable.off('focusout');

      var nextButton = $('.productThumbs').eq(thumbCurrentItem.thumbIndex + 1);

      if (nextButton.length) {
        nextButton.find('a').focus();
      }
    });

    thumbCurrentItem.firstFocusable.focus();
  }
}

// -----------------------------------------------------------
// Product add to cart

var productAdd = function($el) {

  var adding = false;

  var productUpdateButton = function(reset, success) {
    var $button = $el.find('.add-to-cart'),
        $buttonText = $el.find('.add-to-cart-text'),
        text = $buttonText.text();

    if (reset) {
      $button
        .removeClass('active')
        .attr('disabled', 'disabled');
      if (success) {
        $buttonText.text(Theme.localization.product.addedToCart);
        window.buttonInterval = setInterval(function() {
          $buttonText.text(text);
          $button
            .removeClass('disabled')
            .removeAttr('disabled');
          clearInterval(window.buttonInterval);
        }, 4000);
      } else {
        $button
          .removeClass('disabled')
          .removeAttr('disabled');
      }
    } else {
      $button
        .addClass('active disabled')
        .attr('disabled', 'disabled');
    }
  }

  var productAddError = function(errors) {
    var error = $.parseJSON(errors.responseText);

    if (error.message === 'Cart Error') {
      $el.find('.add-to-cart').append(
        '<span class="product-form-error">' + error.description + '</span>'
      );

      var $error = $el.find('.product-form-error');

      $error.addClass('animating');
      setTimeout(function() {
        $error.addClass('visible');
        productUpdateButton(true);
        adding = false;
        setTimeout(function() {
          $error.removeClass('visible');
          setTimeout(function() {
            $error.remove();
          }, 250);
        }, 3000);
      }, 200);
    }
  }

  var productAddItem = function() {
    if (!adding) {
      adding = true;
      productUpdateButton();

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $el.find('form').serialize(),
        dataType: 'json',
        success: function(response) {
          $('[data-header-cart]').trigger('update', response.variant_id);
          adding = false;
        },
        error: function(XMLHttpRequest, textStatus) {
          productAddError(XMLHttpRequest);
        }
      });
    }
  }

  var productAddEvents = function() {
    $el.on('click', '.add-to-cart', function(event) {
      event.preventDefault();
      productAddItem(event);
    });

    $el.on('updateButton', function() {
      productUpdateButton(true, true);
    });
  }

  productAddEvents();
}

var interactiveMedia = {
  featuresLoaded: false,
  instances: {},
  activeMedia: null,

  acceptedTypes: [
    'video',
    'model',
    'external_video'
  ],

  pauseActiveMedia: function() {
    var instance = interactiveMedia.activeMedia;
    if (!instance) { return; }

    if (instance.player) {
      if (instance.type === 'video') {
        instance.player.pause();
      } else if (instance.type === 'external_video') {
        instance.player.pauseVideo();
      }

      interactiveMedia.activeMedia = null;
    }

    if (instance.viewer) {
      interactiveMedia.pauseViewer(instance);
    }
  },

  mediaVisible: function(id, autoPlay) {
    var instance = interactiveMedia.instances[id];
    if (!instance) { return; }

    if (autoPlay) {
      if (instance.type === 'video') {
        instance.player.play();
      } else if (instance.type === 'external_video') {
        instance.player.playVideo();
      } else if (instance.type === 'model') {
        interactiveMedia.playViewer(instance);
      }
    }
  },

  pauseViewer: function(instance) {
    instance.container.classList.remove('model-active');
    interactiveMedia.activeMedia = null;
    instance.viewer.pause();
  },

  playViewer: function(instance) {
    instance.viewer.play();
    instance.container.classList.add('model-active');
    interactiveMedia.activeMedia = instance;
  },

  initMedias: function() {
    var mediaEls = document.querySelectorAll('.interactive-media');

    if (interactiveMedia.featuresLoaded) {
      mediaEls.forEach(interactiveMedia.initEl);
    }

    window.Shopify.loadFeatures([{
      name: 'model-viewer-ui',
      version: '1.0',
    }, {
      name: 'shopify-xr',
      version: '1.0',
    }, {
      name: 'video-ui',
      version: '1.0',
    }], function() {
      interactiveMedia.featuresLoaded = true;

      if ('YT' in window && Boolean(YT.loaded)) {
        mediaEls.forEach(interactiveMedia.initEl);
      } else {
        window.onYouTubeIframeAPIReady = function() {
          mediaEls.forEach(interactiveMedia.initEl);
        }
      }
    });
  },

  initEl: function(el) {
    var mediaId = el.dataset.mediaId;
    var mediaType = el.dataset.mediaType;

    if (!mediaType || !interactiveMedia.acceptedTypes.includes(mediaType)) {
      return;
    }

    var instance = {
      type: mediaType,
      container: el,
      media: el.children[0]
    }

    if (Object.keys(interactiveMedia.instances).includes(mediaId)) { return; }

    switch(instance.type) {
      case 'video':
        instance.player = new Shopify.Plyr(instance.media, {
          loop: { active: el.dataset.loop == 'true' }
        });

        instance.player.poster = el.dataset.poster;
        break;
      case 'model':
        instance.viewer = new Shopify.ModelViewerUI(el.querySelector('model-viewer'));
        break;
      case 'external_video':
        instance.player = new YT.Player(instance.media);
        break;
    }

    interactiveMedia.instances[mediaId] = instance;

    if (instance.player) {
      if (instance.type === 'video') {
        instance.player.on('playing', function() {
          interactiveMedia.activeMedia = instance;
        });
      } else if (instance.type === 'external_video') {
        instance.player.addEventListener('onStateChange', function(event) {
          if (event.data === 1) {
            interactiveMedia.activeMedia = instance;
          }
        })
      }
    }
  }
}

interactiveMedia.initMedias();

$(document).ready(function() {
  productAdd($('[data-product-add-to-cart]'));
});

$(document)
  .on('shopify:section:load', function(event) {
    var section = $(event.target);
    var type = section.attr('class').replace('shopify-section', '').trim();

    interactiveMedia.initMedias();

    switch(type) {
    case 'header':
      timber.cacheSelectors();
      timber.navMenu();
      headerCart($('[data-header-cart]'));
      setupImagePop();
      scrollFX();
      break;
    case 'slideshow':
      scrollFX();
      setSlick(section.find('.slickSlider ul'));
      break;
    case 'featured-content':
      var $fullPageSection = $('.fullPageSectionsWrap');
      if ($fullPageSection.length) {
        $fullPageSection.each(function(i, el) {
          if ($(el).is('[data-animation="true"]')) {
            fullPageSection(el);
          }
        });
      }
      break;
    case 'featured-products':
      setSlick(section.find('.slickSlider ul'));
      $(window).trigger('resize');
      break;
    case 'featured-video':
      initFitVids();
    case 'product-tabs':
      scrollFX();
      setupTabs();
      setupVariantSelector();
      setupImagePop();
      setSlick(section.find('.slickSlider ul'));
      productAdd($('[data-product-add-to-cart]'));
      break;
    case 'twitter-feed':
      initTwitter();
      break;
    case 'contact-page':
      contactMap();
      break;
    };
  })
  .on('shopify:section:unload', function(event) {
    var section = $(event.target);
    var type = section.attr('class').replace('shopify-section', '').trim();

    switch(type) {
      case 'slideshow':
        section.find('.slickSlider ul').slick('unslick');
      case 'featured-products':
        section.find('.slickSlider ul').slick('unslick');
    };
  })
  .on('shopify:section:select', function(event) {
    var section = $(event.target);
    var type = section.attr('class').replace('shopify-section', '').trim();

    switch(type) {
    case 'popout':
      openPopOut('#newsLetter');
      break;
    };
  })
  .on('shopify:section:deselect', function(event) {
    var section = $(event.target);
    var type = section.attr('class').replace('shopify-section', '').trim();

    switch(type) {
    case 'popout':
      closePopout();
      break;
    };
  })
  .on('shopify:block:select', function(event) {
    var slide = $(event.target);

    window.slideshows.forEach(function(slideshow) {
      slideshow.slick('pause');
      slideshow.slick('slickGoTo', slide.attr('data-slick-index'));
    });
  })
  .on('shopify:block:deselect', function(event) {
    window.slideshows.forEach(function(slideshow) {
      slideshow.slick('play');
    });
  });

